import React from 'react';

import { Currencies } from '@constants/constants';

import { Discount } from './style';

interface DiscountLabelProps {
  discount: number | string;
  type?: 'percent' | 'value';
  currency?: string;
}

const DiscountLabel = ({
  discount,
  type = 'percent',
  currency = Currencies.TL,
}: DiscountLabelProps) => (
  <Discount>
    {type === 'percent' ? '%' : ''}
    {discount}
    {type === 'value' ? currency : ''} indirim
  </Discount>
);

export default DiscountLabel;
